import { useEffect, useState } from 'react'

interface NetworkStatus {
  isOnline: boolean
  isWeakSignal: boolean
  downlink?: number
  effectiveType?: string
  rtt?: number
}

export const useNetworkStatus = (): NetworkStatus => {
  const [status, setStatus] = useState<NetworkStatus>({
    isOnline: navigator.onLine,
    isWeakSignal: false
  })

  useEffect(() => {
    const updateStatus = () => {
      const connection = (navigator as any).connection
      const isOnline = navigator.onLine
      let isWeakSignal = false

      if (connection) {
        // Weak signal only if effectiveType is 2g
        if (connection.effectiveType === '2g') {
          isWeakSignal = true
        }
      }

      setStatus({
        isOnline,
        isWeakSignal: isOnline && isWeakSignal, // Only weak if online
        downlink: connection?.downlink,
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt
      })
    }

    window.addEventListener('online', updateStatus)
    window.addEventListener('offline', updateStatus)

    const connection = (navigator as any).connection
    if (connection) {
      connection.addEventListener('change', updateStatus)
    }

    // Initial check
    updateStatus()

    return () => {
      window.removeEventListener('online', updateStatus)
      window.removeEventListener('offline', updateStatus)
      if (connection) {
        connection.removeEventListener('change', updateStatus)
      }
    }
  }, [])

  return status
}
